/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { OrderFlagDTOFromJSON, OrderFlagRequestDTOToJSON, } from '../models/index';
/**
 *
 */
export class OrderFlagControllerApi extends runtime.BaseAPI {
    /**
     */
    async createOrderFlagRaw(requestParameters, initOverrides) {
        if (requestParameters['orderFlagRequestDTO'] == null) {
            throw new runtime.RequiredError('orderFlagRequestDTO', 'Required parameter "orderFlagRequestDTO" was null or undefined when calling createOrderFlag().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/order-flags`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderFlagRequestDTOToJSON(requestParameters['orderFlagRequestDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => OrderFlagDTOFromJSON(jsonValue));
    }
    /**
     */
    async createOrderFlag(requestParameters, initOverrides) {
        const response = await this.createOrderFlagRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async deleteOrderFlagRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling deleteOrderFlag().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/order-flags/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteOrderFlag(requestParameters, initOverrides) {
        await this.deleteOrderFlagRaw(requestParameters, initOverrides);
    }
    /**
     */
    async listOrderFlagsRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/order-flags`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrderFlagDTOFromJSON));
    }
    /**
     */
    async listOrderFlags(initOverrides) {
        const response = await this.listOrderFlagsRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async updateOrderFlagRaw(requestParameters, initOverrides) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling updateOrderFlag().');
        }
        if (requestParameters['orderFlagRequestDTO'] == null) {
            throw new runtime.RequiredError('orderFlagRequestDTO', 'Required parameter "orderFlagRequestDTO" was null or undefined when calling updateOrderFlag().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/order-flags/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrderFlagRequestDTOToJSON(requestParameters['orderFlagRequestDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => OrderFlagDTOFromJSON(jsonValue));
    }
    /**
     */
    async updateOrderFlag(requestParameters, initOverrides) {
        const response = await this.updateOrderFlagRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
